import { Theme } from "types/entities";

export const defaultFontFamily = `Mulish, Arial, sans-serif`;

const commonProperties = {
  custom_font: defaultFontFamily,
  topbar_color: "#ffffff",
  buttons_rounded: false,
  background_color: "#ffffff",
};

export const defaultThemes: Theme[] = [
  {
    id: "defaultBlue",
    active: false,
    default: true,
    name: "Fun blue",
    primary_color: "#1b68b3",
    sidebar_color: "#1b68b3",
    buttons_color: "#1b68b3",
    ...commonProperties,
  },
  {
    id: "defaultOrange",
    active: false,
    default: true,
    name: "Ecstasy",
    primary_color: "#f77a21",
    sidebar_color: "#f77a21",
    buttons_color: "#f77a21",
    ...commonProperties,
  },
  {
    id: "defaultGreen",
    active: false,
    default: true,
    name: "Chateau green",
    primary_color: "#41bd54",
    sidebar_color: "#41bd54",
    buttons_color: "#41bd54",
    ...commonProperties,
  },
  {
    id: "defaultRed",
    active: false,
    default: true,
    name: "Danger red",
    primary_color: "#f20000",
    sidebar_color: "#f20000",
    buttons_color: "#f20000",
    ...commonProperties,
  },
  {
    id: "defaultTurquoise",
    active: false,
    default: true,
    name: "Bright turquoise",
    primary_color: "#2cd1f8",
    sidebar_color: "#2cd1f8",
    buttons_color: "#2cd1f8",
    ...commonProperties,
  },
  {
    id: "defaultBlack",
    active: false,
    default: true,
    name: "Charcoal black",
    primary_color: "#232323",
    sidebar_color: "#232323",
    buttons_color: "#232323",
    ...commonProperties,
  },
  // {
  //   Id: "defaultGray",
  //   Active: false,
  //   Default: true,
  //   Name: "Athens gray",
  //   Primary_color: "#F3F5F7",
  // },
];

export const customFontOptions = {
  font_mulish: defaultFontFamily,
  font_roboto: `Roboto, ${defaultFontFamily}`,
  font_open_sans: `Open Sans, ${defaultFontFamily}`,
  font_helvetica: `Helvetica, ${defaultFontFamily}`,
  font_arial: `Arial, Helvetica, ${defaultFontFamily}`,
  font_montserrat: `Montserrat, ${defaultFontFamily}`,
  font_lato: `Lato, ${defaultFontFamily}`,
  font_source_sans_pro: `Source Sans Pro, ${defaultFontFamily}`,
  font_nunito: `Nunito, ${defaultFontFamily}`,
  font_pt_sans: `PT Sans, ${defaultFontFamily}`,
  font_poppins: `Poppins, ${defaultFontFamily}`,
  font_georgia: `Georgia, ${defaultFontFamily}`,
  font_verdana: `Verdana, Geneva, ${defaultFontFamily}`,
  font_rubik: `Rubik, ${defaultFontFamily}`,
  font_axiforma: `Axiforma, ${defaultFontFamily}`,
};
